angular.module('picmonic-common')
    .factory("BundleBuysResource", ['$resource', function($resource){
        return $resource("/api/v3/bundle_buys/:slug", {bundle_buy_id:'@slug'});
    }]);